import React, { createContext, useState } from 'react';

export const ChangeAllBucketsModalContext = createContext();

export const ChangeAllBucketsModalProvider = ({ children }) => {
  const [isChangeAllBucketsModalOpen, setIsModalOpen] = useState(false);
  
  const toggleChangeAllBucketsModal = () => {
    setIsModalOpen(!isChangeAllBucketsModalOpen);
  };

  return (
    <ChangeAllBucketsModalContext.Provider value={{ isChangeAllBucketsModalOpen, setIsModalOpen, toggleChangeAllBucketsModal }}>
      {children}
    </ChangeAllBucketsModalContext.Provider>
  );
};

